export const PIPELINE_STAGES = {
    PENDING_ENQUIRY: {
      id: 'PENDING_ENQUIRY',
      title: 'Pending Enquiry',
      description: 'Enquiries awaiting review.',
      color: 'bg-orange-50',
      headerColor: 'bg-orange-100'
    },
    NEW: {
      id: 'NEW',
      title: 'Enquiry',
      description: 'Fresh enquiries waiting for initial review.',
      color: 'bg-gray-50',
      headerColor: 'bg-gray-100'
    },
    FEASIBILITY: {
      id: 'FEASIBILITY',
      title: 'Feasibility',
      description: 'Technical feasibility check in progress.',
      color: 'bg-amber-50',
      headerColor: 'bg-amber-100'
    },
    PENDING_PRICE: {
      id: 'PENDING_PRICE',
      title: 'Pending Price',
      description: 'Awaiting pricing from the team.',
      color: 'bg-yellow-50',
      headerColor: 'bg-yellow-100'
    },
    OFFER_SUBMITTED: {
      id: 'OFFER_SUBMITTED',
      title: 'Offer',
      description: 'Offer sent to the customer.',
      color: 'bg-blue-50',
      headerColor: 'bg-blue-100'
    },
    DEAL_LOST: {
      id: 'DEAL_LOST',
      title: 'Order Lost',
      description: 'Customer declined or deal closed as lost.',
      color: 'bg-red-50',
      headerColor: 'bg-red-100'
    },
    DEAL_WON: {
      id: 'DEAL_WON',
      title: 'Order Won',
      description: 'Order confirmed and won.',
      color: 'bg-green-50',
      headerColor: 'bg-green-100'
    },
  };

export const getPipelineStageOptions = () => {
  return Object.values(PIPELINE_STAGES);
};

export const getStageById = (stageId) => {
  return PIPELINE_STAGES[stageId] || null;
};
